// extracted by mini-css-extract-plugin
module.exports = {"container":"StatisticsCalendarSelection_container__3_FTX","calendar":"StatisticsCalendarSelection_calendar__2n4ow"};